import * as React from 'react'
import { FormikHelpers } from 'formik'

import { Form, Forms, Username, Password } from '@ally/forms'
import { Button, Link, Space, TextBody } from '@ally/metronome-ui'
import { AsyncStatus, BankToAutoLinkingProps } from '@ally/transmitigator'

import { InputWrapper } from '../Shared'
import { getAAOSForgotPasswordUrl, getAAOSForgotUsernameUrl } from '../../Utils'

interface AutoLoginFormProps {
  onComplete: BankToAutoLinkingProps['onComplete']
  status: AsyncStatus
}

interface AutoLoginFormState {
  username: string
  password: string
}

export const AutoLoginForm: React.FC<AutoLoginFormProps> = ({
  onComplete,
  status,
}) => {
  const formId = 'auto-login-form'
  const initialValues: AutoLoginFormState = {
    username: '',
    password: '',
  }
  const handleSubmit = (
    formValues: AutoLoginFormState,
    { setSubmitting }: FormikHelpers<AutoLoginFormState>,
  ): void => {
    onComplete(formValues)

    setSubmitting(false)
  }

  return (
    <>
      <Forms
        formId={formId}
        initialValues={initialValues}
        onSubmit={handleSubmit}
      >
        <Form id={formId}>
          <InputWrapper mb="md">
            <Username name="username" useDefaultValidate />
          </InputWrapper>

          <InputWrapper mb="lg">
            <Password
              adornment="passwordMask"
              name="password"
              useDefaultValidate
            />
            <Space mt="xxs">
              <TextBody size="sm" tag="p">
                Forgot{' '}
                <Link
                  target="_blank"
                  text="username"
                  href={getAAOSForgotUsernameUrl()}
                  allytmln="forgotUsername"
                />{' '}
                or{' '}
                <Link
                  target="_blank"
                  text="password"
                  href={getAAOSForgotPasswordUrl()}
                  allytmln="forgotPassword"
                />
                ?
              </TextBody>
            </Space>
          </InputWrapper>

          <Button
            allytmln="Link Accounts"
            loading={status === 'Loading'}
            text="Link Accounts"
            type="submit"
            variant="primary"
          />
        </Form>
      </Forms>
    </>
  )
}
